/**
 * A PortPuffin mailbox holder's subscription vocabulary: its lifecycle status and its plan tier.
 * A LEAF subpath (`@puffin-core/status-taxonomy/mailbox-holder-subscription`) that requires nothing, so a browser bundle
 * (port-web's holder portal and its admin list) imports it without the rest of the package — the
 * `subscription-status` precedent. `constants.js` re-exports these, so there is ONE definition and the root surface
 * carries them too.
 *
 * pos-api reads a holder's subscription status ACROSS apps (CUSTOMER-ERASURE-REACH step 2: an active subscription
 * blocks a customer's erasure up front), and port-api's model, its routes and port-web's two holder surfaces each
 * spelled these values by hand. The values are the columns' CHECK constraints
 * (`20260416050948_create_port_mailbox_holder_sku_tables.js`: `mailboxHolderSubscriptions.status` and `.planTier`; the
 * plans catalog's `mailboxHolderPlans_tier_chk`), so a rename is a migration, never a refactor.
 * @module @puffin-core/status-taxonomy/mailbox-holder-subscription
 */

'use strict';

/** A holder subscription's lifecycle status (`mailboxHolderSubscriptions.status`). */
const MAILBOX_HOLDER_SUBSCRIPTION_STATUS = Object.freeze({
  ACTIVE: 'active',
  SUSPENDED: 'suspended',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
});

const MAILBOX_HOLDER_SUBSCRIPTION_STATUS_VALUES = Object.freeze(
  Object.values(MAILBOX_HOLDER_SUBSCRIPTION_STATUS),
);

/** A holder plan's tier (`mailboxHolderSubscriptions.planTier`, `mailboxHolderPlans.tier`). */
const MAILBOX_HOLDER_PLAN_TIER = Object.freeze({
  BASIC: 'basic',
  PREMIUM: 'premium',
});

const MAILBOX_HOLDER_PLAN_TIER_VALUES = Object.freeze(Object.values(MAILBOX_HOLDER_PLAN_TIER));

module.exports = {
  MAILBOX_HOLDER_SUBSCRIPTION_STATUS,
  MAILBOX_HOLDER_SUBSCRIPTION_STATUS_VALUES,
  MAILBOX_HOLDER_PLAN_TIER,
  MAILBOX_HOLDER_PLAN_TIER_VALUES,
};
